import React from "react";
import moment from "moment";

export default class JobStockRow extends React.Component {
  constructor(props) {
    super(props);
    this.details = this.details.bind(this);
  }

  details() {
    const { RowData } = this.props;
    this.props.history.push(
      (window.ReactNativeWebView ? "/single-page" : "") +
        "/job/Job-stock-check-detail/" +
        RowData.Alias +
        "/" +
        btoa(
          JSON.stringify({
            Name: RowData.Site.Name,
            Alias: RowData.Site.Alias,
            Category: RowData.Site.Category
          })
        )
    );
  }

  render() {
    const { RowData } = this.props;

    return (
      <tr onClick={this.details}>
        <td>{RowData.Site.Name}</td>
        <td>
          <div className="total-asset">{RowData.Asset_Count}&nbsp;Asset</div>
        </td>
        <td>{moment(RowData.CreatedTime).format("ll")}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/job/job_stock_check/helper/component/JobStockRow.js